// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MenuItem":"bgo_a bhs_un bhs_cw bhs_a","MenuItem__Btn":"bgo_b bhs_z"};